import {Divider} from '@/components/ui/divider/Divider'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ProjectFormHeading} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeading'
import {ProjectReopeningFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {useToggle} from '@/hooks/useToggle'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {ProjectReopeningConfirmationModal} from '@/features/projects/components/project-reopening-confirmation-modal/ProjectReopeningConfirmationModal'
import {ProjectReopeningFormSections} from '@/features/projects/components/project-form/project-reopening-form-sections/ProjectReopeningFormSections'
import {ProjectReopeningFormProvider} from '@/features/projects/components/project-form/project-reopening-form-provider/ProjectReopeningFormProvider'

export const ProjectReopening = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    if (!permissions?.projects.write) {
        return <NoPermissionBox />
    }

    return (
        <PageCardWrapper>
            <Helmet title={t('projects:reopen_meta_title')} />
            <ProjectReopeningFormProvider project={project}>
                <ProjectFormHeadingWrapper project={project} isAllowed={project.status == 'closed'} />
                <Divider direction="horizontal" />
                <PageContent padding={0}>
                    <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                        <ProjectReopeningFormSections />
                    </ScrollArea>
                </PageContent>
            </ProjectReopeningFormProvider>
        </PageCardWrapper>
    )
}

export const ProjectFormHeadingWrapper = ({project, isAllowed}: {project: ProjectExtended; isAllowed: boolean}) => {
    const {t} = useTranslation()
    const {on: showConfirmationModal, off: hideConfirmationModal, isActive: isConfirmationModalVisible} = useToggle()

    return (
        <>
            <ProjectFormHeading
                title={t('projects:reopen_project_title')}
                schema={ProjectReopeningFormValidationSchema}
                showConfirmationModal={showConfirmationModal}
                buttonLabel={t('projects:reopen_project')}
                showSubmitButton={isAllowed}
            />
            {isConfirmationModalVisible && (
                <ProjectReopeningConfirmationModal project={project} hide={hideConfirmationModal} />
            )}
        </>
    )
}
